// @flow

import { buildCommonComponent } from '@zapier/legacy-components';

import 'web-ssr/app/common/components/Text.scss';

export const Text = buildCommonComponent('text')('', 'span');
export const Paragraph = buildCommonComponent('text')('--paragraph', 'p');

export default Text;
